import { render, staticRenderFns } from "./realtime.vue?vue&type=template&id=a01553e0&scoped=true&"
import script from "./realtime.vue?vue&type=script&lang=js&"
export * from "./realtime.vue?vue&type=script&lang=js&"
import style0 from "./realtime.vue?vue&type=style&index=0&id=a01553e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01553e0",
  null
  
)

/* custom blocks */
import block0 from "./realtime.vue?vue&type=custom&index=0&blockType=router&lang=js"
if (typeof block0 === 'function') block0(component)

export default component.exports